var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowDown = function (_a) {
    var className = _a.className;
    return (_jsx("svg", __assign({ className: className, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M4 6L8 10L12 6", stroke: "#A7B4C8", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default ArrowDown;
//# sourceMappingURL=arrowDown.js.map